import React, { useContext, useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { BookmarkBorder, Delete } from '@material-ui/icons/'
import { useKeycloak } from '@react-keycloak/web'

import searchPageContext from '../../FiltersComponent/context/context'
import { loadOVSearchCriteria, loadSearchCriteria } from '../../Utility/LoadSavedSearch/LoadSavedSearch'
import { formatDate, getUserSFId, getErrorAlertDuration } from '../../Utility/Utility'
import ApplyFilters from '../../FiltersComponent/ApplyFilters/ApplyFilters'
import SearchSavedSearch from '../SearchSavedSearch/SearchSavedSearch'
import { deleteSavedSearch } from '../../Services/propertySearchService'
import { pollMessageStatus } from '../../../PropertyList/Utility/GetMessageStatus/GetMessageStatus'
import { readyToUpdate, pendingResponse } from '../../../PropertyList/Utility/PropertyListUtility'
// import getSavedSearch from '../../Utility/GetSavedSearch/GetSavedSearch'

const SelectExistingSearch = props => {

    const ApplyFiltersRef = useRef()
    const { keycloak } = useKeycloak()
    const [criteriaProcessed, setCriteriaProcessed] = useState(false)
    const [checkedSavedSearch, setCheckedSavedSearch] = useState()
    const [inputSearchSaved, setInputSearchSaved] = useState('')
    // const [selectedItem, setSelectedItem] = useState('')

    let { savedSearch, fetchSavedSearch, setalertProps, setShowAlert, setSearchFields, setSearchCriteria,
        setSelectedMenu, searchCriteria, setShowSpinner, setPreSearchCriteria, preSearchCriteria, openModalWindow
    } = useContext(searchPageContext)

    useEffect(() => {

        if (criteriaProcessed) {
            setCriteriaProcessed(false)
            ApplyFiltersRef.current.callhandleClick()
            if (searchCriteria.subjectProperty.propertyName) {
                let searchTypeVal = searchCriteria.salesFields.length > 0 ? 'sales' : 'rent'
                setPreSearchCriteria({ ...preSearchCriteria, searchType: searchTypeVal })
            }
            else {
                setPreSearchCriteria({ ...preSearchCriteria, searchType: 'prospecting' })
            }
            setSelectedMenu('search')
        }

    }, [criteriaProcessed])

    const handleClick = selectedSearch => {
        if (props.view === 'select') {
            // ClearFiltersRef.current.callhandleClear()
            // console.log('searchCriteria b4:::', searchCriteria)
            // let omniViewSearchCriteriaTemp = { "searchCriteria": [{ "ParameterCond": "((DISTANCE(PropertyAddress__c, GEOLOCATION(40.72951339999999,-73.99646089999999), 'mi') < 5))", "PageName": "PropertySearchNew", "ParameterName": "PointOfInterest", "ParameterValue": "New York University" }, { "ParameterCond": "(Type__c IN (%27Student Housing%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyType", "ParameterValue": "Student Housing : All" }, { "ParameterCond": "TotalUnits__c <= 100", "PageName": "PropertySearchNew", "ParameterName": "_unitsMax", "ParameterValue": "Units < 100" }, { "ParameterCond": " Order By DISTANCE(PropertyAddress__c, GEOLOCATION(40.72951339999999,-73.99646089999999), 'mi') asc ", "PageName": "PropertySearchNew", "ParameterName": "OrderBy", "ParameterValue": "OrderBy" }] }
            // selectedSearch.omniViewSearchCriteria = JSON.stringify(omniViewSearchCriteriaTemp)

            if (!selectedSearch.polarisSearchCriteria && !selectedSearch.omniViewSearchCriteria) {
                setalertProps({ message: 'This Saved Search cannot be used, please create a new Saved Search!! ', type: 'error' })
                setShowAlert(true)
                return
            }

            if (selectedSearch.polarisSearchCriteria && selectedSearch.polarisSearchCriteria !== '') {
                loadSearchCriteria(selectedSearch.polarisSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
            } else {
                setShowSpinner(true)
                loadOVSearchCriteria(selectedSearch.omniViewSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
            }

            // if (selectedSearch.omniViewSearchCriteria && selectedSearch.omniViewSearchCriteria !== '') {
            //     setShowSpinner(true)
            //     loadOVSearchCriteria(selectedSearch.omniViewSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
            // } else {
            //     loadSearchCriteria(selectedSearch.polarisSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
            // }

            let queryParam = `userId=${getUserSFId()}&view=search`
            window.history.pushState({}, 'Property Search', '/PropertySearch?' + queryParam)
        }
    }

    const getDeletePayload = item => {
        try {
            const user_SFId = getUserSFId()

            const payload = {
                'action': 'delete',
                'data': {
                    'isCart': false,
                    'userId': keycloak.subject,
                    'omniViewUserId': user_SFId,
                    'polarisLastModifiedById': keycloak.subject,
                    // 'dataSource': 'PolarisDelete',
                    'omniViewPropertyListId': item.omniViewPropertyListId,
                    'polarisPropertySearchCriteriaId': item.polarisPropertySearchCriteriaId
                }
            }
            return payload
        }
        catch (e) {
            console.log('Error :: ', e)
        }
    }

    const onDelete = async (message, type) => {

        try {

            if (type === 'success') {
                await fetchSavedSearch()
            }

            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Delete :: ', error)
        }

    }

    const handleDelete = async (item) => {
        try {

            setCheckedSavedSearch(item)

            const payload = getDeletePayload(item)

            let response
            if (await readyToUpdate()) {
                openModalWindow(true)
                response = await deleteSavedSearch(payload)
            } else {
                response = await pendingResponse()
            }

            setCheckedSavedSearch(undefined)

            if (response && response.status === 200) {
                pollMessageStatus(response.data.messageId, onDelete, '', 'Search Deleted!! ', 'Something went wrong !!')
            } else {
                const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                setalertProps({ message: errorMessage, type: 'error' })
                setShowAlert(true)
            }

            // setCheckedSavedSearch(undefined)
            // if (response && response.status === 200) {
            //     removeSearch(item)
            //     setalertProps({ message: 'Search Deleted!! ', type: 'success' })
            //     setShowAlert(true)
            // }

        } catch (e) {
            console.log('Error in handle-Delete::: ', e)
            setalertProps({ message: 'Something went wrong!! ', type: 'error' })
            setShowAlert(true)
        }
    }

    const showDeleteSpinner = item => {
        let returnVal = false

        if (checkedSavedSearch) {
            if (item.polarisPropertySearchCriteriaId === checkedSavedSearch.polarisPropertySearchCriteriaId) {
                returnVal = true
            }
        }

        return returnVal
    }

    const getSavedSearchCount = () => {
        let count = 0
        if (inputSearchSaved) {
            count = savedSearch.filter(x => !x.isCart && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase())).length
        } else {
            count = savedSearch.filter(x => !x.isCart).length
        }

        return `Your Searches (${count})`
    }

    const getSavedSearches = () => {
        if (inputSearchSaved) {
            return savedSearch.filter(x => !x.isCart && x.name.toLowerCase().includes(inputSearchSaved.toLowerCase()))
        } else {
            return savedSearch.filter(x => !x.isCart)
        }
    }

    const handleChange = e => {
        const { value } = e.target
        setInputSearchSaved(value)
    }

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-12">
                <div className="overflow-hidden ">

                </div>
                <div className="md:col-span-9 overflow-hidden ">
                    <div data-testid="test-div-update-save-search" className="flex flex-col pt-4">
                        <div className="flex flex-row border-b-1 border-base pb-4">
                            <SearchSavedSearch handleChange={handleChange} inputSearchSaved={inputSearchSaved} setInputSearchSaved={setInputSearchSaved} ></SearchSavedSearch>
                            {/* <SearchSavedSearch /> */}
                        </div>
                        <div className="flex flex-row border-b-1 border-base py-4">
                            <span className="px-2 font-medium">
                                {getSavedSearchCount()}
                            </span>
                        </div>

                        <div className="border-1 border-base flex flex-col overflow-y-auto disable-scrollbars">
                            {getSavedSearches().map(value => (
                                <>
                                    {!value.isCart &&
                                        <div className="grid grid-cols-6 border-b-1 border-base hover:bg-gray-15 items-center py-3 text-2">
                                            <div data-testid={`test-select-search-${value.name}`} onClick={() => { handleClick(value) }} key={value.name} className="text-base col-span-3 px-3 cursor-pointer">
                                                <div className="flex flex-row">
                                                    <div>
                                                        <BookmarkBorder></BookmarkBorder>
                                                    </div>
                                                    <div className="px-3 font-medium">
                                                        {value.name}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-span-2 flex flex-col">
                                                <div className="font-medium">
                                                    {formatDate(value.lastModifiedDate, 'mmDDYYYY')}
                                                </div>
                                                <div className="text-muted text-1 py-1">Last Modified</div>
                                            </div>
                                            <div className="col-span-1 flex justify-end">
                                                <div className={`float-right cursor-pointer px-3 ${value.isTargetMarket ? 'invisible' : ''}`} >
                                                    <button data-testid={`test-btn-delete-${value.name}`} className={`btn ${showDeleteSpinner(value) ? 'c-disabled' : ''}`} onClick={() => { handleDelete(value) }}>
                                                        {showDeleteSpinner(value) ? <span className="loader h-5 w-5 mx-2" ></span> : <Delete fontSize="small" />}
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                            ))}
                        </div>
                        {savedSearch.filter(x => !x.isCart).length === 0 &&
                            <div className="p-6 border-b-1 border-base">
                                You can Save a Search or a Target market.
                                <br />Come back here to load your saved search.
                            </div>
                        }
                        <div className="p-4">
                            <div className="flex justify-end space-x-4 mt-auto">
                                <div className="hidden">
                                    <ApplyFilters ref={ApplyFiltersRef} handleClose={() => { }} criteriaToApply="all"></ApplyFilters>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="overflow-hidden ">

                </div>
            </div>


        </>
    )
}

export default SelectExistingSearch

SelectExistingSearch.propTypes = {
    handleClose: PropTypes.any,
    view: PropTypes.string
}
